// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-container {
  padding: 20px;
  border-radius: 8px;
  font-family: "Arial", sans-serif;
}
.timeline-container .timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.timeline-container .timeline-header .filter-btn,
.timeline-container .timeline-header .export-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #ddd;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.timeline-container .timeline-header .timeline-range {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.timeline-container .timeline-header .timeline-range label {
  font-weight: 600;
  margin-bottom: 15px;
}
.timeline-container .timeline-header .timeline-range .date-range-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}
.timeline-container .timeline-header .timeline-range .date-range-inputs input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  width: 140px;
}
.timeline-container .timeline-header .timeline-range .date-range-inputs span {
  font-weight: bold;
  color: #333;
}
.timeline-container .timeline-content {
  font-size: 16px;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/pages/Timeline/Timeline.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,gCAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AACJ;AACI;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AACN;AAEI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAN;AAEM;EACE,gBAAA;EACA,mBAAA;AAAR;AAGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADR;AAGQ;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AADV;AAIQ;EACE,iBAAA;EACA,WAAA;AAFV;AAQE;EAEE,eAAA;EACA,WAAA;AAPJ","sourcesContent":[".timeline-container {\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  font-family: 'Arial', sans-serif;\r\n\r\n  .timeline-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n\r\n    .filter-btn,\r\n    .export-btn {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 6px;\r\n      background: #fff;\r\n      border: 1px solid #ddd;\r\n      padding: 6px 12px;\r\n      border-radius: 4px;\r\n      font-size: 14px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .timeline-range {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n\r\n      label {\r\n        font-weight: 600;\r\n        margin-bottom: 15px;\r\n      }\r\n\r\n      .date-range-inputs {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n\r\n        input {\r\n          padding: 6px 10px;\r\n          border: 1px solid #ccc;\r\n          border-radius: 4px;\r\n          text-align: center;\r\n          width: 140px;\r\n        }\r\n\r\n        span {\r\n          font-weight: bold;\r\n          color: #333;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .timeline-content {\r\n    // width: 40%;\r\n    font-size: 16px;\r\n    color: #555;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
